import cake from "../../../core/assets/icons/cake-lg.svg?raw";
import desserts from "../../../core/assets/icons/desserts.svg?raw";
import sladkaDilna from "../../../core/assets/icons/sladka-dilna.svg?raw";
import type { Step } from "../../../core/schema/Step.js";

export const christmasSteps: Step[] = [
	{
		title: "Objednáte si cukroví",
		description: "Přidejte do krabice, na co máte chuť. V nabídce jsou mixy různých velikostí i jednotlivé druhy.",
		icon: desserts,
	},
	{
		title: "My napečeme za vás",
		description: "Veškerou práci nechte letos na nás a užijte si předvánoční čas v klidu s rodinou.",
		icon: cake,
	},
	{
		title: "Vy si jen vyzvednete",
		description: "Cukroví stačí jen vyzvednout na vámi zvolené pobočce. Sladké a veselé bez pečení!",
		icon: sladkaDilna,
	},
];
